import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'
import CircleIcon from '@mui/icons-material/Circle'
import React, {useState} from 'react'
import {useAppDispatch} from '../../../app/hooks'
import {useNavigate} from 'react-router-dom'
import {deleteUserAccount} from '@meprism/shared/src/redux/authentication/authenticationSlice'
import AnalyticsManager from '../../../services/AnalyticsManager'

const styles = {
  bulletIcon: {
    fontSize: '8px',
    color: 'black',
  },
  delAcc: {
    background: 'white',
    border: '1px solid #c67eff',
    color: '#c67eff !important',
    '&:hover': {
      color: 'white !important',
      background: '#c67eff',
    },
    '&:disabled': {
      color: 'C67EFF !important',
      background: 'white',
    },
  },
  dialogPaper: {
    borderRadius: '16px',
    padding: '24px 28px',
  },
  listIconWidth: {
    minWidth: '35px',
  },
  listItem: {
    py: '4px'
  },
  dialogTitle: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: 'center',
    fontFamily: 'InterBold',
    color: 'rgb(26, 27, 32)',
    p: 0,
  },
  dialogContent: {
    p: 0,
  },
  listText: {
    color: 'rgb(26, 27, 32)',
    fontSize: 14, 
    fontFamily: 'InterMedium',
    p: 0,
  },
}

const DeleteAcc = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [isOpenDialog, setOpenDialog] = useState(false)

  const handleDeleteAcc = async () => {
    await dispatch(deleteUserAccount())
    await AnalyticsManager.trackTypedEvent(
      {
        event: "Account Deleted - Web",
        source: 'Web App'
      }
    )
    navigate('/login')
  }

  const closeDeleteAccDialog = () => {
    setOpenDialog(false)
  }

  return (
    <>
      <Grid item md={12} xs={12}>
        <Typography variant="h3">Delete Account</Typography>
      </Grid>

      <Grid item md={12}>
        <Button sx={styles.delAcc} onClick={() => setOpenDialog(true)}>
          Delete Account
        </Button>
      </Grid>
      <Dialog
        open={isOpenDialog}
        onClose={closeDeleteAccDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: styles.dialogPaper,
        }}
        >
        <DialogTitle sx={styles.dialogTitle}>
          Are you sure you want to delete your account?
        </DialogTitle>
        <DialogContent  sx={styles.dialogContent}>
          <DialogContentText>
            <Grid item md={12}>
              <List>
                {[
                  'This will permanently delete your mePrism account and you will lose all your opt out progress & profile info.',
                  'We will no longer be supporting you to remove your personal information from the internet.',
                  'The authorization agreement will be deemed terminated.',
                  'This action can not be undone.',
                ].map((text, i) => (
                  <ListItem key={i} sx={styles.listItem}>
                    <ListItemIcon sx={styles.listIconWidth}>
                      <CircleIcon sx={styles.bulletIcon} />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{ sx: styles.listText }}
                      primary={text}
                    />
                  </ListItem>
                ))}
              </List>

            </Grid>
          </DialogContentText>
          <DialogActions sx={styles.dialogContent}>
            <Button
              size="small"
              variant="outlined"
              onClick={closeDeleteAccDialog}>
              Cancel
            </Button>
            <Button size="small" variant="outlined" color="error" onClick={handleDeleteAcc}>
              Delete Account
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default DeleteAcc
